// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutShippingCarrierServiceStyles } from "@steiner/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { css } from "styled-components";

checkoutShippingCarrierServiceStyles.container = {
    gap: 16,
};

checkoutShippingCarrierServiceStyles.carrierGridItem = {
    width: 12,
};

checkoutShippingCarrierServiceStyles.serviceGridItem = {
    width: 12,
};

checkoutShippingCarrierServiceStyles.deliveryDateGridItem = {
    width: 12,
};

checkoutShippingCarrierServiceStyles.deliveryDateGridItem = {
    width: 12,
    css: css`
        & > div {
            width: 100%;
        }
    `,
};

checkoutShippingCarrierServiceStyles.deliveryDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

checkoutShippingCarrierServiceStyles.notesGridItem = {
    width: 12,
};
